import { DocumentData, JsonContent, Result, Section } from '../types';

// translate this from salesforce
export const selectFieldsWithOptions = (intl: any, field: string) => {
  const contractItemType = [
    { label: intl.formatMessage({ id: 'sim_card_connection_costs' }), value: 'SIM_card_&_connection_costs' },
    { label: intl.formatMessage({ id: 'emergency_standby_service' }), value: 'emergency_standby_service' },
    {
      label: intl.formatMessage({ id: 'emergency_device_rental_exclusive_sim_card_connection_costs' }),
      value: 'emergency_device_rental_exclusive_SIM_card_&_connection_costs',
    },
    {
      label: intl.formatMessage({ id: 'emergency_device_rental_including_sim_card_connection_costs' }),
      value: 'emergency_device_rental_including_SIM_card_&_connection_costs',
    },
    { label: intl.formatMessage({ id: 'emergency_connection' }), value: 'emergency_connection' },
    { label: intl.formatMessage({ id: 'maintenance_12' }), value: 'maintenance_12' },
    { label: intl.formatMessage({ id: 'maintenance_6' }), value: 'maintenance_6' },
    { label: intl.formatMessage({ id: 'maintenance_4' }), value: 'maintenance_4' },
    { label: intl.formatMessage({ id: 'maintenance_2' }), value: 'maintenance_2' },
    { label: intl.formatMessage({ id: 'maintenance_1' }), value: 'maintenance_1' },
    { label: intl.formatMessage({ id: 'maintenance_0_5' }), value: 'maintenance_0_5' },
    { label: intl.formatMessage({ id: 'maintenance_idle' }), value: 'maintenance_idle' },
    { label: intl.formatMessage({ id: 'monitoring' }), value: 'elevator_monitoring' },
    { label: intl.formatMessage({ id: 'zues_main' }), value: 'zues_main' },
    { label: intl.formatMessage({ id: 'zues_intermediate' }), value: 'zues_intermediate' },
    { label: intl.formatMessage({ id: 'zues_resit' }), value: 'zues_resit' },
    { label: intl.formatMessage({ id: 'zues_service_technician' }), value: 'zues_service_technician' },
    { label: intl.formatMessage({ id: 'zues_inspection_system' }), value: 'zues_inspection_system' },
    { label: intl.formatMessage({ id: 'emergency_rescue' }), value: 'emergency_rescue' },
    { label: intl.formatMessage({ id: 'liftguard_instruction' }), value: 'liftguard_instruction' },
    { label: intl.formatMessage({ id: 'surchages' }), value: 'surchages' },
    { label: intl.formatMessage({ id: 'fault_elimination' }), value: 'fault_elimination' },
    { label: intl.formatMessage({ id: 'travel_expenses' }), value: 'travel_expenses' },
    { label: intl.formatMessage({ id: 'wages_bill' }), value: 'wages_bill' },
    { label: intl.formatMessage({ id: 'emergencycall_rent' }), value: 'emergencycall_rent' },
    { label: intl.formatMessage({ id: 'repair' }), value: 'repair' },
    { label: intl.formatMessage({ id: 'servicing' }), value: 'servicing' },
    {
      label: intl.formatMessage({ id: 'zues_all_options_main_intermediate' }),
      value: 'zues_all_options_main_intermediate',
    },
    { label: intl.formatMessage({ id: 'zues_options_main' }), value: 'zues_options_main' },
    { label: intl.formatMessage({ id: 'zues_options_intermediate' }), value: 'zues_options_intermediate' },
    { label: intl.formatMessage({ id: 'zues_travel_expenses' }), value: 'zues_travel_expenses' },
    { label: intl.formatMessage({ id: 'liftguard_service_manual' }), value: 'liftguard_service_manual' },
    { label: intl.formatMessage({ id: 'liftguard_service_electronic' }), value: 'liftguard_service_electronic' },
    { label: intl.formatMessage({ id: 'keysafe_rental' }), value: 'keysafe_rental' },
    { label: intl.formatMessage({ id: 'shaft_smokeextraction' }), value: 'shaft_smokeextraction' },
    { label: intl.formatMessage({ id: 'maintenance_reg' }), value: 'maintenance_reg' },
  ];

  const days = [
    { label: intl.formatMessage({ id: 'monday' }), value: 'monday' },
    { label: intl.formatMessage({ id: 'tuesday' }), value: 'tuesday' },
    { label: intl.formatMessage({ id: 'wednesday' }), value: 'wednesday' },
    { label: intl.formatMessage({ id: 'thursday' }), value: 'thursday' },
    { label: intl.formatMessage({ id: 'friday' }), value: 'friday' },
    { label: intl.formatMessage({ id: 'saturday' }), value: 'saturday' },
    { label: intl.formatMessage({ id: 'sunday' }), value: 'sunday' },
    { label: intl.formatMessage({ id: 'holiday' }), value: 'holiday' },
    { label: intl.formatMessage({ id: 'sunday_holiday' }), value: 'sunday_holiday' },
    { label: intl.formatMessage({ id: 'every_day' }), value: 'every_day' },
  ];

  const calculationType = [
    { label: intl.formatMessage({ id: 'per_month' }), value: 'per month' },
    { label: intl.formatMessage({ id: 'per_quarter' }), value: 'per quarter' },
    { label: intl.formatMessage({ id: 'per_unit' }), value: 'per unit' },
    { label: intl.formatMessage({ id: 'per_year' }), value: 'per year' },
  ];

  const type = [
    { label: intl.formatMessage({ id: 'maintenance' }), value: 'Maintenance' },
    { label: intl.formatMessage({ id: 'sim_card_connection_costs' }), value: 'SIM_card_&_connection_costs' },
    { label: intl.formatMessage({ id: 'emergency_standby_service' }), value: 'emergency_standby_service' },
    {
      label: intl.formatMessage({ id: 'emergency_device_rental_exclusive_sim_card_connection_costs' }),
      value: 'emergency_device_rental_exclusive_SIM_card_&_connection_costs',
    },
    {
      label: intl.formatMessage({ id: 'emergency_device_rental_including_sim_card_connection_costs' }),
      value: 'emergency_device_rental_including_SIM_card_&_connection_costs',
    },
    { label: intl.formatMessage({ id: 'emergency_connection' }), value: 'emergency_connection' },
    { label: intl.formatMessage({ id: 'monitoring' }), value: 'elevator_monitoring' },
    { label: intl.formatMessage({ id: 'zues_main' }), value: 'zues_main' },
    { label: intl.formatMessage({ id: 'zues_intermediate' }), value: 'zues_intermediate' },
    { label: intl.formatMessage({ id: 'zues_resit' }), value: 'zues_resit' },
    { label: intl.formatMessage({ id: 'zues_service_technician' }), value: 'zues_service_technician' },
    { label: intl.formatMessage({ id: 'zues_inspection_system' }), value: 'zues_inspection_system' },
    { label: intl.formatMessage({ id: 'emergency_rescue' }), value: 'Personenbefreiung' },
    { label: intl.formatMessage({ id: 'liftguard_instruction' }), value: 'liftguard_instruction' },
    { label: intl.formatMessage({ id: 'surchages' }), value: 'surchages' },
    { label: intl.formatMessage({ id: 'fault_elimination' }), value: 'Störungsbeseitigung' },
    { label: intl.formatMessage({ id: 'travel_expenses' }), value: 'travel_expenses' },
    { label: intl.formatMessage({ id: 'wages_bill' }), value: 'wages_bill' },
    { label: intl.formatMessage({ id: 'emergencycall_rent' }), value: 'emergencycall_rent' },
    { label: intl.formatMessage({ id: 'repair' }), value: 'repair' },
    { label: intl.formatMessage({ id: 'servicing' }), value: 'servicing' },
    {
      label: intl.formatMessage({ id: 'zues_all_options_main_intermediate' }),
      value: 'zues_all_options_main_intermediate',
    },
    { label: intl.formatMessage({ id: 'zues_options_main' }), value: 'zues_options_main' },
    { label: intl.formatMessage({ id: 'zues_options_intermediate' }), value: 'zues_options_intermediate' },
    { label: intl.formatMessage({ id: 'zues_travel_expenses' }), value: 'zues_travel_expenses' },
    { label: intl.formatMessage({ id: 'liftguard_service_manual' }), value: 'liftguard_service_manual' },
    { label: intl.formatMessage({ id: 'liftguard_service_electronic' }), value: 'liftguard_service_electronic' },
    { label: intl.formatMessage({ id: 'keysafe_rental' }), value: 'keysafe_rental' },
    { label: intl.formatMessage({ id: 'shaft_smokeextraction' }), value: 'shaft_smokeextraction' },
    { label: intl.formatMessage({ id: 'maintenance_idle' }), value: 'maintenance_idle' },
  ];
  const options = {
    invoice_type: [
      { label: intl.formatMessage({ id: 'tax_invoice' }), value: 'tax_invoice' },
      { label: intl.formatMessage({ id: 'credit_note' }), value: 'credit_note' },
      // { label: intl.formatMessage({ id: 'work_receipt' }), value: 'work_receipt' },
      // { label: intl.formatMessage({ id: 'other' }), value: 'other' },
      // { label: intl.formatMessage({ id: 'receipt' }), value: 'receipt' },
    ],
    invoice_kind: [
      { label: intl.formatMessage({ id: 'recurring' }), value: 'recurring' },
      { label: intl.formatMessage({ id: 'non-recurring' }), value: 'non-recurring' },
    ],
    invoice_reason: [
      { label: intl.formatMessage({ id: 'n_a' }), value: '-1' },
      { label: intl.formatMessage({ id: 'maintenance_contract' }), value: 'maintenance_contract' },
      { label: intl.formatMessage({ id: 'incident' }), value: 'incident' },
      { label: intl.formatMessage({ id: 'zues' }), value: 'zues' },
      { label: intl.formatMessage({ id: 'repair' }), value: 'repair' },
      { label: intl.formatMessage({ id: 'emergency_contract' }), value: 'emergency_contract' },
      { label: intl.formatMessage({ id: 'provide_technician_zues' }), value: 'provide_technician_zues' },
      { label: intl.formatMessage({ id: 'person_rescue' }), value: 'person_rescue' },
      { label: intl.formatMessage({ id: 'relaunch_after_shutdown' }), value: 'relaunch_after_shutdown' },
      { label: intl.formatMessage({ id: 'operator_obligations' }), value: 'operator_obligations' },
      { label: intl.formatMessage({ id: 'object_access' }), value: 'object_access' },
      { label: intl.formatMessage({ id: 'project_consulting' }), value: 'project_consulting' },
      { label: intl.formatMessage({ id: 'preventive_measure' }), value: 'preventive_measure' },
      { label: intl.formatMessage({ id: 'shutdown' }), value: 'shutdown' },
      { label: intl.formatMessage({ id: 'construction' }), value: 'construction' },
      { label: intl.formatMessage({ id: 'condition_report' }), value: 'condition_report' },
      { label: intl.formatMessage({ id: 'visualization' }), value: 'visualization' },
      { label: intl.formatMessage({ id: 'azw' }), value: 'azw' },
      { label: intl.formatMessage({ id: 'support_for_zues' }), value: 'support_for_zues' },
      { label: intl.formatMessage({ id: 'property_accesss' }), value: 'property_accesss' },
      { label: intl.formatMessage({ id: 'elevator_attendance' }), value: 'elevator_attendance' },
      { label: intl.formatMessage({ id: 'passenger_release' }), value: 'passenger_release' },
    ],
    item_cost_group: [
      { label: intl.formatMessage({ id: 'allowance' }), value: 'Allowance' },
      { label: intl.formatMessage({ id: 'blower' }), value: 'blower' },
      { label: intl.formatMessage({ id: 'brake' }), value: 'brake' },
      { label: intl.formatMessage({ id: 'buffer' }), value: 'buffer' },
      { label: intl.formatMessage({ id: 'cabin_doors' }), value: 'cabin_doors' },
      { label: intl.formatMessage({ id: 'cabin_floor_cover' }), value: 'cabin_floor_cover' },
      { label: intl.formatMessage({ id: 'cabin_folding_seat' }), value: 'cabin_folding_seat' },
      { label: intl.formatMessage({ id: 'cabin_handrail' }), value: 'cabin_handrail' },
      { label: intl.formatMessage({ id: 'cabin_lightning' }), value: 'cabin_lightning' },
      { label: intl.formatMessage({ id: 'cable' }), value: 'cable' },
      {
        label: intl.formatMessage({ id: 'check_system_for_zues_inspction' }),
        value: 'check_system_for_ZUES_inspction',
      },
      { label: intl.formatMessage({ id: 'check_weight' }), value: 'check weight' },
      { label: intl.formatMessage({ id: 'circular_saw' }), value: 'circular_saw' },
      { label: intl.formatMessage({ id: 'concierge_automatic' }), value: 'concierge_automatic' },
      { label: intl.formatMessage({ id: 'concierge_manual' }), value: 'concierge_manual' },
      { label: intl.formatMessage({ id: 'concision' }), value: 'concision' },
      { label: intl.formatMessage({ id: 'condition_report' }), value: 'condition_report' },
      { label: intl.formatMessage({ id: 'controls' }), value: 'controls' }, //
      { label: intl.formatMessage({ id: 'counter_weight' }), value: 'counter_weight' },
      { label: intl.formatMessage({ id: 'cylinder_head' }), value: 'cylinder_head' },
      { label: intl.formatMessage({ id: 'dguv_bgv_a3' }), value: 'dguv_bgv_a3' },
      { label: intl.formatMessage({ id: 'distribution_packaging' }), value: 'distribution_packaging' },
      { label: intl.formatMessage({ id: 'diverter_pulley' }), value: 'Diverter_pulley' },
      { label: intl.formatMessage({ id: 'door_beam' }), value: 'door_beam' },
      { label: intl.formatMessage({ id: 'door_castor' }), value: 'door_castor' },
      { label: intl.formatMessage({ id: 'door_latch' }), value: 'door_latch' },
      { label: intl.formatMessage({ id: 'door_motor' }), value: 'door_motor' },
      { label: intl.formatMessage({ id: 'drum' }), value: 'drum' },
      { label: intl.formatMessage({ id: 'elevator_car_railing' }), value: 'elevator_car_railing' },
      { label: intl.formatMessage({ id: 'emergenc_call_device' }), value: 'emergenc_call_device' },
      { label: intl.formatMessage({ id: 'emergency_allowance' }), value: 'emergency_allowance' },
      { label: intl.formatMessage({ id: 'emergency_call_rent' }), value: 'emergency_call_rent' },
      { label: intl.formatMessage({ id: 'emergency_call_standby' }), value: 'emergency_call_standby' },
      { label: intl.formatMessage({ id: 'emergency_electricity_battery' }), value: 'emergency_electricity_battery' },
      { label: intl.formatMessage({ id: 'emergency_escape_instruction' }), value: 'emergency_escape_instruction' },
      { label: intl.formatMessage({ id: 'emergency_light_battery' }), value: 'emergency_light_battery' },
      { label: intl.formatMessage({ id: 'emergency_plan' }), value: 'emergency_plan' },
      { label: intl.formatMessage({ id: 'emergency_release' }), value: 'emergency_release' },
      { label: intl.formatMessage({ id: 'emergency_stop' }), value: 'emergency_stop' },
      { label: intl.formatMessage({ id: 'expertise' }), value: 'expertise' },
      { label: intl.formatMessage({ id: 'floor_display' }), value: 'floor_display' },
      { label: intl.formatMessage({ id: 'frequency_inverter' }), value: 'Frequency_inverter' },
      { label: intl.formatMessage({ id: 'fuse' }), value: 'fuse' },
      { label: intl.formatMessage({ id: 'gear_drive' }), value: 'gear_drive' },
      { label: intl.formatMessage({ id: 'guidance' }), value: 'guidance' },
      { label: intl.formatMessage({ id: 'guidance_inlay' }), value: 'guidance_inlay' },
      { label: intl.formatMessage({ id: 'guidance_rails' }), value: 'guidance_rails' },
      { label: intl.formatMessage({ id: 'guidance_rolls' }), value: 'guidance_rolls' },
      { label: intl.formatMessage({ id: 'hanging_cable' }), value: 'hanging_cable' },
      { label: intl.formatMessage({ id: 'hydraulic_aggregate' }), value: 'hydraulic_aggregate' },
      { label: intl.formatMessage({ id: 'hydraulic_cylinder' }), value: 'hydraulic_cylinder' },
      { label: intl.formatMessage({ id: 'hydraulic_oil' }), value: 'hydraulic_oil' },
      { label: intl.formatMessage({ id: 'hydraulic_valve' }), value: 'hydraulic_valve' },
      { label: intl.formatMessage({ id: 'hydraulic_pump' }), value: 'hydraulic pump' },
      { label: intl.formatMessage({ id: 'incremental_encoder' }), value: 'incremental_encoder' },
      { label: intl.formatMessage({ id: 'inspection_control' }), value: 'inspection_control' },
      { label: intl.formatMessage({ id: 'key_depot' }), value: 'key_depot' },
      { label: intl.formatMessage({ id: 'key_switch' }), value: 'key_switch' },
      { label: intl.formatMessage({ id: 'ladder' }), value: 'ladder' },
      { label: intl.formatMessage({ id: 'leak_oil_system' }), value: 'leak_oil_system' },
      { label: intl.formatMessage({ id: 'light_curtain_sensor' }), value: 'light_curtain_sensor' },
      { label: intl.formatMessage({ id: 'lightning_machine_room' }), value: 'lightning_machine_room' },
      { label: intl.formatMessage({ id: 'load_weighting_facility' }), value: 'load_weighting_facility' },
      { label: intl.formatMessage({ id: 'maintenance' }), value: 'maintenance' },
      { label: intl.formatMessage({ id: 'maintenance_emergency_call' }), value: 'maintenance_emergency_call' },
      { label: intl.formatMessage({ id: 'mirror' }), value: 'mirror' },
      { label: intl.formatMessage({ id: 'motor' }), value: 'motor' },
      { label: intl.formatMessage({ id: 'motor_oil' }), value: 'motor_oil' },
      { label: intl.formatMessage({ id: 'mounting_production_zues' }), value: 'mounting_production_zues' },
      { label: intl.formatMessage({ id: 'n_a' }), value: '-- n/a --' },
      { label: intl.formatMessage({ id: 'new_building' }), value: 'new_building' },
      { label: intl.formatMessage({ id: 'oilproof_paint' }), value: 'oilproof_paint' },
      { label: intl.formatMessage({ id: 'passenger_rescue' }), value: 'passenger_rescue' },
      { label: intl.formatMessage({ id: 'protections' }), value: 'protections' },
      { label: intl.formatMessage({ id: 'pump_motor' }), value: 'Pump_motor' },
      { label: intl.formatMessage({ id: 'push_button' }), value: 'push_button' },
      { label: intl.formatMessage({ id: 'rail_oiler' }), value: 'rail_oiler' },
      { label: intl.formatMessage({ id: 'relais' }), value: 'relais' },
      { label: intl.formatMessage({ id: 'replacement_check_book' }), value: 'replacement_check_book' },
      { label: intl.formatMessage({ id: 'restoration' }), value: 'restoration' },
      { label: intl.formatMessage({ id: 'risk_assessment' }), value: 'risk_assessment' },
      { label: intl.formatMessage({ id: 'ropes' }), value: 'ropes' },
      { label: intl.formatMessage({ id: 'safety_catch' }), value: 'safety_catch' },
      { label: intl.formatMessage({ id: 'safety_circuit' }), value: 'Safety_circuit' },
      { label: intl.formatMessage({ id: 'seal' }), value: 'seal' },
      { label: intl.formatMessage({ id: 'seperation_door' }), value: 'seperation_door' },
      { label: intl.formatMessage({ id: 'servicing' }), value: 'servicing' },
      { label: intl.formatMessage({ id: 'shaft_copy' }), value: 'shaft_copy' },
      { label: intl.formatMessage({ id: 'shaft_desmoking' }), value: 'shaft_desmoking' },
      { label: intl.formatMessage({ id: 'shaft_doors' }), value: 'shaft_doors' },
      { label: intl.formatMessage({ id: 'shaft_lightning' }), value: 'shaft_lightning' },
      { label: intl.formatMessage({ id: 'shaft_pit' }), value: 'shaft_pit' },
      { label: intl.formatMessage({ id: 'shaft_smoke_extraction' }), value: 'shaft_smoke_extraction' },
      { label: intl.formatMessage({ id: 'signs' }), value: 'signs' },
      { label: intl.formatMessage({ id: 'soft_drive_device' }), value: 'soft_drive_device' },
      { label: intl.formatMessage({ id: 'solenoid_switch' }), value: 'Solenoid_switch' },
      { label: intl.formatMessage({ id: 'special_control_safety' }), value: 'special_control_safety' },
      { label: intl.formatMessage({ id: 'speed_delimiter' }), value: 'speed_delimiter' },
      { label: intl.formatMessage({ id: 'tableau' }), value: 'tableau' },
      { label: intl.formatMessage({ id: 'tacho' }), value: 'tacho' },
      { label: intl.formatMessage({ id: 'tank_heater_cooling' }), value: 'tank_heater_cooling' },
      { label: intl.formatMessage({ id: 'telefone_connection' }), value: 'telefone_connection' },
      { label: intl.formatMessage({ id: 'training' }), value: 'training' },
      { label: intl.formatMessage({ id: 'travel_expense' }), value: 'travel_expense' },
      { label: intl.formatMessage({ id: 'twoway_intercom' }), value: 'twoway_intercom' },
      { label: intl.formatMessage({ id: 'undercurrent_power_unit' }), value: 'undercurrent_power_unit' },
      { label: intl.formatMessage({ id: 'valves' }), value: 'valves' },
      { label: intl.formatMessage({ id: 'visualization' }), value: 'visualization' },
      { label: intl.formatMessage({ id: 'wall_shroud' }), value: 'wall_shroud' },
      { label: intl.formatMessage({ id: 'zues_check_aws' }), value: 'zues_check_aws' },
      { label: intl.formatMessage({ id: 'zues_check_certificate' }), value: 'zues_check_certificate' },
      { label: intl.formatMessage({ id: 'zues_inspection_after_change' }), value: 'zues_inspection_after_change' },
      { label: intl.formatMessage({ id: 'zues_intermediate_check' }), value: 'ZUES_intermediate_check' },
      { label: intl.formatMessage({ id: 'zues_main_inspection' }), value: 'ZUES_main_inspection' },
      { label: intl.formatMessage({ id: 'zues_re_check' }), value: 'zues_re-check' },
      { label: intl.formatMessage({ id: 'door_drive' }), value: 'door_drive' },
      { label: intl.formatMessage({ id: 'wage_costs' }), value: 'wage_costs' },
      { label: intl.formatMessage({ id: 'travel_expenses' }), value: 'travel_expenses' },
      { label: intl.formatMessage({ id: 'emergency_service_fee' }), value: 'emergency_service_fee' },
      { label: intl.formatMessage({ id: 'drive' }), value: 'drive' },
      { label: intl.formatMessage({ id: 'maintenance_and_emergency_call' }), value: 'maintenance_and_emergency_call' },
      { label: intl.formatMessage({ id: 'zeus_supplementary_inspection' }), value: 'zeus_supplementary_inspection' },
      { label: intl.formatMessage({ id: 'zues_modification_inspection' }), value: 'zues_modification_inspection' },
      { label: intl.formatMessage({ id: 'emergency_call_charge' }), value: 'emergency_call_charge' },
      { label: intl.formatMessage({ id: 'commitment_fee' }), value: 'commitment_fee' },
      { label: intl.formatMessage({ id: 'fitter_hourly_rate' }), value: 'fitter_hourly_rate' },
      { label: intl.formatMessage({ id: 'door_rollers' }), value: 'door_rollers' },
      { label: intl.formatMessage({ id: 'car_lighting' }), value: 'car_lighting' },
      { label: intl.formatMessage({ id: 'emergency_battery' }), value: 'emergency_battery' },
      { label: intl.formatMessage({ id: 'test_system_zues' }), value: 'test_system_zues' },
      { label: intl.formatMessage({ id: 'monitoring_device' }), value: 'monitoring_device' },
      { label: intl.formatMessage({ id: 'labour_costs' }), value: 'labour_costs' },
      { label: intl.formatMessage({ id: 'provision_of_fitters_zuez' }), value: 'provision_of_fitters_zuez' },
      { label: intl.formatMessage({ id: 'passenger_release' }), value: 'passenger_release' },
      { label: intl.formatMessage({ id: 'car_handrail' }), value: 'car_handrail' },
      { label: intl.formatMessage({ id: 'emergency_unlocking' }), value: 'emergency_unlocking' },
      { label: intl.formatMessage({ id: 'door_lock' }), value: 'door_lock' },
      { label: intl.formatMessage({ id: 'floor_selector' }), value: 'floor_selector' },
      { label: intl.formatMessage({ id: 'flushness' }), value: 'flushness' },
      { label: intl.formatMessage({ id: 'engine_drive' }), value: 'engine_drive' },
      { label: intl.formatMessage({ id: 'rebate' }), value: 'rebate' },
      { label: intl.formatMessage({ id: 'emergency_oncall_service' }), value: 'emergency_oncall_service' },
      { label: intl.formatMessage({ id: 'zues_intermediate_inspection' }), value: 'zues_intermediate_inspection' },
      { label: intl.formatMessage({ id: 'zeus_main_inspection' }), value: 'zeus_main_inspection' },
      { label: intl.formatMessage({ id: 'lump_sum' }), value: 'lump_sum' },
    ],
    calculation_type: calculationType,
    type,
    assessment_type_pick: [
      { label: intl.formatMessage({ id: 'main_check' }), value: 'main_check' },
      { label: intl.formatMessage({ id: 'intermediate_check' }), value: 'intermediate_check' },
      { label: intl.formatMessage({ id: 'dguv_v3' }), value: 'dguv_a3' },
      { label: intl.formatMessage({ id: 'recheck' }), value: 'recheck' },
      { label: intl.formatMessage({ id: 'first_acceptance' }), value: 'first_acceptance' },
      { label: intl.formatMessage({ id: 'whg_awsv' }), value: 'whg_awsv' },
      { label: intl.formatMessage({ id: 'main_check_continued' }), value: 'main_check_continued' },
      { label: intl.formatMessage({ id: 'intermediate_check_continued' }), value: 'intermediate_check_continued' },
      { label: intl.formatMessage({ id: 'commissioning' }), value: 'commissioning' },
      { label: intl.formatMessage({ id: 'conformity' }), value: 'conformity' },
      { label: intl.formatMessage({ id: 'check_after_change' }), value: 'check_after_change' },
      { label: intl.formatMessage({ id: 'check_after_change_on_site' }), value: 'check_after_change_on_site' },
      { label: intl.formatMessage({ id: 'recurring_inspection' }), value: 'recurring_inspection' },
      { label: intl.formatMessage({ id: 'operational_inspection' }), value: 'operational_inspection' },
      { label: intl.formatMessage({ id: 'intermediate_check_canceled' }), value: 'intermediate_check_canceled' },
      { label: intl.formatMessage({ id: 'main_check_canceled' }), value: 'main_check_canceled' },
      { label: intl.formatMessage({ id: 'conformity_canceled' }), value: 'conformity_canceled' },
      { label: intl.formatMessage({ id: 'check_before_recommissioning' }), value: 'check_before_recommissioning' },
      {
        label: intl.formatMessage({ id: 'operational_inspection_canceled' }),
        value: 'operational_inspection_canceled',
      },
      {
        label: intl.formatMessage({ id: 'check_before_recommissioning_canceled' }),
        value: 'check_before_recommissioning_canceled',
      },
      { label: intl.formatMessage({ id: 'commissioning_canceled' }), value: 'comissioning_canceled' },
    ],
    assessment_result_pick: [
      { label: intl.formatMessage({ id: 'without_deficiencies' }), value: 'without_deficiencies' },
      { label: intl.formatMessage({ id: 'minor_deficiencies' }), value: 'minor_deficiencies' },
      { label: intl.formatMessage({ id: 'extensive_deficiencies' }), value: 'extensive_deficiencies' },
      { label: intl.formatMessage({ id: 'dangerous_deficiencies' }), value: 'dangerous_deficiencies' },
      { label: intl.formatMessage({ id: 'unclassified_deficiencies' }), value: 'unclassified_deficiencies' },
      { label: intl.formatMessage({ id: 'assessment_cancelled' }), value: 'assessment_cancelled' },
    ],
    item_result_pick: [
      { label: intl.formatMessage({ id: 'extensive_deficiencies' }), value: 'extensive_deficiencies' },
      { label: intl.formatMessage({ id: 'dangerous_deficiencies' }), value: 'dangerous_deficiencies' },
      { label: intl.formatMessage({ id: 'minor_deficiencies' }), value: 'minor_deficiencies' },
      { label: intl.formatMessage({ id: 'unclassified_deficiency' }), value: 'unclassified_deficiency' },
    ],
    contract_type: [
      { label: intl.formatMessage({ id: 'azw_contract_type' }), value: 'azw' },
      { label: intl.formatMessage({ id: 'basic_maintenance' }), value: 'basic_maintenance' },
      { label: intl.formatMessage({ id: 'basic_maintenance_emergency' }), value: 'basic_maintenance_emergency' },
      { label: intl.formatMessage({ id: 'downtime_maintenance' }), value: 'downtime_maintenance' },
      { label: intl.formatMessage({ id: 'elevator_monitoring' }), value: 'elevator_monitoring' },
      { label: intl.formatMessage({ id: 'emergency' }), value: 'emergency' },
      { label: intl.formatMessage({ id: 'emergencysystem_rent' }), value: 'emergencysystem_rent' },
      { label: intl.formatMessage({ id: 'full_maintenance' }), value: 'full_maintenance' },
      { label: intl.formatMessage({ id: 'full_maintenance_emergency' }), value: 'full_maintenance_emergency' },
      { label: intl.formatMessage({ id: 'heavy_maintenance' }), value: 'heavy_maintenance' },
      { label: intl.formatMessage({ id: 'partial_maintenance' }), value: 'part_maintenance' },
      { label: intl.formatMessage({ id: 'partial_maintenance_emergency' }), value: 'partial_maintenance_emergency' },
      { label: intl.formatMessage({ id: 'shaft_smoke_extraction' }), value: 'shaft_smoke_extraction' },
      { label: intl.formatMessage({ id: 'zues' }), value: 'zues' },
    ],
    item_contract_option_name: contractItemType,
    calculation_type_frequency: calculationType,
    calculation_type_reaction_time: calculationType,
    item_rates_surcharges_type: [
      { label: intl.formatMessage({ id: 'master' }), value: 'master' },
      { label: intl.formatMessage({ id: 'travel_piece' }), value: 'travel_piece' },
      { label: intl.formatMessage({ id: 'travel_km' }), value: 'travel_km' },
      { label: intl.formatMessage({ id: 'technician' }), value: 'technician' },
      { label: intl.formatMessage({ id: 'emergency_service_rate' }), value: 'Emergency service rate' },
      { label: intl.formatMessage({ id: 'personal_rescue_rate' }), value: 'Personal rescue rate' },
      { label: intl.formatMessage({ id: 'small_and_consumable_items' }), value: 'Small_and_consumable items' },
      { label: intl.formatMessage({ id: 'remote_diagnosis' }), value: 'Remote_diagnosis' },
      { label: intl.formatMessage({ id: 'remote_fault_clearance' }), value: 'Remote_fault_clearance' },
      { label: intl.formatMessage({ id: 'appointment_surcharge' }), value: 'Appointment_surcharge' },
      { label: intl.formatMessage({ id: 'express_surcharge' }), value: 'Express_surcharge' },
      { label: intl.formatMessage({ id: 'appointment_postponement' }), value: 'Appointment_postponement' },
      { label: intl.formatMessage({ id: 'unsuccessful_inspection' }), value: 'Unsuccessful_inspection' },
    ],
    item_rates_surcharges_start_day: days,
    item_rates_surcharges_end_day: days,
    quotation_type: [
      { label: intl.formatMessage({ id: 'repair_assessment_report' }), value: 'repair_assessment_report' },
      { label: intl.formatMessage({ id: 'repair_maintenance' }), value: 'repair_maintenance' },
      { label: intl.formatMessage({ id: 'repair_risk_report' }), value: 'repair_risk_report' },
      { label: intl.formatMessage({ id: 'modernisation' }), value: 'modernisation' },
      { label: intl.formatMessage({ id: 'new_installation' }), value: 'new_installation' },
      { label: intl.formatMessage({ id: 'repair_breakdown' }), value: 'repair_breakdown' },
      { label: intl.formatMessage({ id: 'other' }), value: 'other' },
      { label: intl.formatMessage({ id: 'out_of_order' }), value: 'out_of_order' },
    ],
    document_type: [
      { label: intl.formatMessage({ id: 'work_report' }), value: 'work_report' },
      { label: intl.formatMessage({ id: 'order_placed_by_customer' }), value: 'order_placed_by_customer' },
      {
        label: intl.formatMessage({ id: 'maintenance_report' }),
        value: 'maintenance_report',
      },
      { label: intl.formatMessage({ id: 'order_confirmation' }), value: 'order_confirmation' },
      { label: intl.formatMessage({ id: 'gbu_report' }), value: 'document_GBU_report' },
      { label: intl.formatMessage({ id: 'cancellation_confirmation' }), value: 'cancellation_confirmation' },
// { label: intl.formatMessage({ id: 'contract' }), value: 'Contract' },
// { label: intl.formatMessage({ id: 'power_of_attorney' }), value: 'power_of_attorney' },
// { label: intl.formatMessage({ id: 'power_of_attorney_alt' }), value: 'power_of-attorney' },
// { label: intl.formatMessage({ id: 'price_adjustment' }), value: 'price_adjustment' },
// { label: intl.formatMessage({ id: 'incident_report' }), value: 'incident_report' },
// { label: intl.formatMessage({ id: 'repair_report' }), value: 'repair_report' },
// { label: intl.formatMessage({ id: 'warning' }), value: 'warning' },
// { label: intl.formatMessage({ id: 'change_of_ownership' }), value: 'change_of_ownership' },
// { label: intl.formatMessage({ id: 'change_of_operator' }), value: 'change_of_operator' },
// { label: intl.formatMessage({ id: 'change_of_administrator' }), value: 'change_of_administrator' },
// { label: intl.formatMessage({ id: 'address_change' }), value: 'address_change' },
// { label: intl.formatMessage({ id: 'termination_of_contract' }), value: 'termination_of_contract' },
// { label: intl.formatMessage({ id: 'elevator_inspection' }), value: 'elevator_inspection' },
      { label: intl.formatMessage({ id: 'notification_passenger_release' }), value: 'Notification_passenger_release' },
//      { label: intl.formatMessage({ id: 'protocol_emergency_call' }), value: 'protocol_emergency_call' },
//      {
//        label: intl.formatMessage({ id: 'certificate_of_participation_azw' }),
//        value: 'Certificate of participation AZW',
//      },
      {
        label: intl.formatMessage({ id: 'emergency_plan' }),
        value: 'emergency_plan',
      },
      { label: intl.formatMessage({ id: 'emergency_release_instructions' }), value: 'emergency_release_instructions' },
      {
        label: intl.formatMessage({ id: 'miscellaneous' }),
        value: 'miscellaneous',
      },
      // {
      //   label: intl.formatMessage({ id: 'maintenance_checklist' }), value: 'maintenance_checklist'
      // },
      {
        label: intl.formatMessage({ id: 'zues_appointment' }),
        value: 'zues_appointment',
      },
    ],
    is_framework_agreement: [
      {
        label: intl.formatMessage({ id: 'yes' }),
        value: 'yes',
      },
      {
        label: intl.formatMessage({ id: 'no' }),
        value: 'no',
      },
    ],
    'response_times_type': [
      { label: intl.formatMessage({ id: 'emergency_rescue' }), value: 'Personenbefreiung' },
      { label: intl.formatMessage({ id: 'fault_elimination' }), value: 'Störungsbeseitigung' },
    ],
  };

  return options[field] || [];
};

export const dateSchemas = ['due_date_invoice', 'due_date_discount', 'date_issue'];

export const selectFields = [
  'invoice_type',
  'document_type',
  'invoice_kind',
  'invoice_reason',
  'item_cost_group',
  'calculation_type',
  'type',
  'assessment_type_pick',
  'assessment_result_pick',
  'item_result_pick',
  'contract_type',
  'item_contract_option_name',
  'calculation_type_frequency',
  'calculation_type_reaction_time',
  'item_rates_surcharges_type',
  'item_rates_surcharges_start_day',
  'item_rates_surcharges_end_day',
  'quotation_type',
  'is_framework_agreement',
];

// Maps schema_ids to the ?type= query param sent to the search API
export const factorySelectFields: Record<string, string> = {
  item_factory_id: 'elevators',
  factory_id: 'elevators',
  item_charged_service_elevator_factory_id: 'elevators',
};

export const receiverNameSelectFields = [
  'service_receiver_name',
   'sender_name',
   'recipient_name',
   'service_provider',
   'name_invoice_receiver'
];

// Maps each name field to the schema_id of its single combined address field.
// Update the schema_ids below to match the actual field names in your form schema.
export const nameToAddressFieldMap: Record<string, { address: string }> = {
  'sender_name': { address: 'sender_address' },
  // 'service_receiver_name': { address: 'service_receiver_address' },
  // 'recipient_name': { address: 'recipient_address' },
  // 'service_provider': { address: 'service_provider_address' },
  'name_invoice_receiver': { address: 'address_invoice_receiver' },
};

// Maps each name field to its corresponding address field for city-based tie-breaking.
export const nameToInitialAddressFieldMap: Record<string, string> = {
  'service_receiver_name': 'service_receiver_address',
  'name_invoice_receiver': 'address_invoice_receiver',
  'sender_name': 'sender_address',
  'recipient_name': 'recipient_address',
  'service_provider': 'service_provider_address',
};

export const hideFormSectionsBasedOnType = type => {
  switch (type) {
    case 'Customer_Invoice_Stage':
    case 'Customer_Invoice_Prod':
      return ['service_location', 'service_receiver_address', 'sender_vat_id'];
    case 'Assessment_Report_Prod':
    case 'Assessment_Report_Stage':
      return ['anka_key'];
    case 'Customer_Contract_Prod':
      return [];
    case 'Customer_Document_Prod':
      return [];
    case 'Customer_Quotation_Prod':
      return [];
    case 'Price_Adjustment_Prod':
      return [];
    default:
      return [];
  }
};

export function moveEmailInfoSectionToBottom(data) {
  if (!data || !Array.isArray(data.content)) {
    return data;
  }

  // Create a copy of the original data to avoid mutating the input
  const result = JSON.parse(JSON.stringify(data));

  // Find the index of the email_info_section
  const emailSectionIndex = result.content.findIndex(item => item.schema_id === 'email_info_section');

  // If found, remove it from its current position and push to the end
  if (emailSectionIndex !== -1) {
    const [emailSection] = result.content.splice(emailSectionIndex, 1);
    result.content.push(emailSection);
  }

  return result;
}

export const conditionalFieldConfig = {
  next_assessment: {
    dependsOn: 'general_info_section.assessment_type_pick',
    hideWhen: ['operational_inspection'],
  },
  due_date_fixed: {
    dependsOn: 'general_info_section.assessment_type_pick',
    hideWhen: ['operational_inspection'],
  },
  dangers_according_to_defect_712: {
    dependsOn: 'general_info_section.assessment_type_pick',
    hideWhen: ['operational_inspection'],
  },
  observation_item_section: {
    dependsOn: 'general_info_section.assessment_type_pick',
    hideWhen: ['operational_inspection'],
  },
};

export function fixJSONDates(jsonData: Section[]) {
  const data =
    typeof jsonData === "string" ? JSON.parse(jsonData) : JSON.parse(JSON.stringify(jsonData));

  const pad2 = (n: number) => (n < 10 ? `0${n}` : `${n}`);
  // ✅ Apex/Salesforce safe format
  const out = (d: number, m: number, y: number) => `${y}-${pad2(m)}-${pad2(d)}`;

  const MONTH_NAMES: Record<string, number> = {
    // English
    january: 1, february: 2, march: 3, april: 4, may: 5, june: 6,
    july: 7, august: 8, september: 9, october: 10, november: 11, december: 12,
    // German
    januar: 1, februar: 2, märz: 3, mai: 5, juni: 6, juli: 7,
    oktober: 10, dezember: 12,
  };

  function isValidYMD(y: number, m: number, d: number) {
    if (y < 1900 || y > 9999) return false;
    if (m < 1 || m > 12) return false;
    const dt = new Date(y, m - 1, d);
    return dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d;
  }

  function convertDateValue(value: string): string {
    if (!value || typeof value !== "string") return value;
    const v = value.trim();
    if (!v) return value;

    // ISO-like with time: 2025-10-28T12:34:56Z
    let m = v.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)$/);
    if (m) {
      const y = +m[1], mo = +m[2], d = +m[3];
      if (isValidYMD(y, mo, d)) return out(d, mo, y);
      return ""; // Invalid date in ISO format
    }

    // YYYY[-./]MM[-./]DD → normalize
    m = v.match(/^(\d{2,4})[.\-\/](\d{1,2})[.\-\/](\d{1,4})$/);
    if (m) {
      const first = +m[1], second = +m[2], third = +m[3];

      // Check if it's YYYY-MM-DD format (first number has 4 digits)
      if (m[1].length === 4) {
        const y = first, mo = second, d = third;
        if (isValidYMD(y, mo, d)) return out(d, mo, y);
        return ""; // Invalid date
      }

      // Check if it's DD-MM-YYYY format (third number has 4 digits)
      if (m[3].length === 4) {
        const d = first, mo = second, y = third;
        if (isValidYMD(y, mo, d)) return out(d, mo, y);
        return ""; // Invalid date
      }
    }

    // DD[-./]MM → default year to current year, e.g. "12.3" → "2026-03-12"
    m = v.match(/^(\d{1,2})[.\-/](\d{1,2})$/);
    if (m) {
      const d = +m[1], mo = +m[2], y = new Date().getFullYear();
      if (isValidYMD(y, mo, d)) return out(d, mo, y);
      return "";
    }

    // MM[-./]YYYY → default day to 01
    m = v.match(/^(\d{1,2})[.\-/](\d{4})$/);
    if (m) {
      const mo = +m[1], y = +m[2];
      if (isValidYMD(y, mo, 1)) return out(1, mo, y);
      return "";
    }

    // "Month YYYY" or "Month. YYYY" → e.g. "September 2026", "August 1993", German month names
    const monthMatch = v.match(/^([A-Za-z\u00C0-\u024F]+)\.?\s+(\d{4})$/);
    if (monthMatch) {
      const mo = MONTH_NAMES[monthMatch[1].toLowerCase()];
      const y = +monthMatch[2];
      if (mo && isValidYMD(y, mo, 1)) return out(1, mo, y);
      return "";
    }

    // Clear relative/textual date expressions (e.g. "8 Wochen ab dem 10.11.2020")
    if (/wochen\s+ab|tage\s+ab|ab\s+dem/i.test(v)) return '';

    return value; // not a recognizable date format
  }

  function processObject(obj: any) {
    if (obj && typeof obj === "object") {
      if (obj.type === "date" && typeof obj.value === "string") {
        try { obj.value = convertDateValue(obj.value); } catch {}
      }
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] && typeof obj[key] === "object") {
          processObject(obj[key]);
        }
      }
    }
  }

  if (Array.isArray(data)) data.forEach(processObject);
  else processObject(data);

  return data;
}

const EMAIL_BODY_MAX_LENGTH = 6000;

/** Slice email_body field values to EMAIL_BODY_MAX_LENGTH for processedData. */
export function sliceEmailBodyInContent(jsonData: Section[]): Section[] {
  const data =
    typeof jsonData === 'string' ? JSON.parse(jsonData) : JSON.parse(JSON.stringify(jsonData));

  function processItem(obj: any) {
    if (obj && typeof obj === 'object') {
      if (obj.schema_id === 'email_body' && typeof obj.value === 'string' && obj.value.length > EMAIL_BODY_MAX_LENGTH) {
        obj.value = obj.value.slice(0, EMAIL_BODY_MAX_LENGTH);
      }
      if (Array.isArray(obj.children)) obj.children.forEach(processItem);
      for (const key in obj) {
        if (key !== 'children' && Object.prototype.hasOwnProperty.call(obj, key) && obj[key] && typeof obj[key] === 'object') {
          processItem(obj[key]);
        }
      }
    }
  }

  if (Array.isArray(data)) data.forEach(processItem);
  else processItem(data);

  return data;
}
